/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import TopBar from '../../components/TopBar';

import CardHeader from '../../components/CardHeader';
import TableSection from './components/Table';
import GlobalContext from '../../components/Context/GlobalContext';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { AdminUser } from './adminUserSlice';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import Pagination from '../../components/Pagination';
import { dataService } from '../../services/data.services';
import Confirmationpopup from './components/Confirmationpopup';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
const ManageAdminUsers = () => {

    const { isSideNavBar, setToastErrorMessage, setToastmessage, toastErrorMessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const AdminUserList = useSelector(state => state.adminUserState);
    const { List } = AdminUserList;
    const [modalpopup, setmodalpopup] = useState({})
    const [activateLoading, setactivateLoading] = useState(false)
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [addOpen, setAddOpen] = useState(false)
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [sideModelType, setSideModelType] = useState('');
    const [searchParams, setSearchParams] = useSearchParams({ page_number: 1 });
    const [email, setemail] = useState('')
    const [tableLoading, setTableLoading] = useState(false)
    const [editValue, setEditValue] = useState({})
    const initialInputValue = {
        admin_first_name: '',
        admin_last_name: '',
        admin_email_address: '',
        admin_mobile_number: '',
        roles: []
    }
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [inputValue, setInputValue] = useState(initialInputValue);
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */

    const handleLoadData = () => {
        setLoading(true);
        let params = null
        params.page_number = 1
        params.filter = true
        params.status = true
        setSearchParams({ ...params })
    }
    /* `const getAdminUserList` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getAdminUserList` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getAdminUserList = useCallback(async () => {
        setEmptyScreenMessage("")
        try {
            dispatch(AdminUser(searchParams)).then((response) => {
                if (response?.payload?.data?.success_status) {
                    if (Math.ceil(response?.payload?.data?.totat_count / 10) < Number(searchParams.get('page_number'))) {
                        if (response?.payload?.data?.totat_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if (email === '') {
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            handleLoadData()
            console.error(error);
        }
    }, [location]);



    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (key === 'search') params[key] = encodeURIComponent(value)
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }

    const handleFilters = (key, value) => {
        setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.filter = true
        if (key === 'all') {
            delete params['filter'];
            delete params['status'];
        }
        else params[key] = value
        setSearchParams({ ...params })
    }

    /* `useEffect(() => { getAdminUserList(); }, [getAdminUserList]);` is a hook that is used to run
    the `getAdminUserList` function whenever the `getAdminUserList` function changes. In this case,
    the `getAdminUserList` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getAdminUserList` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {

        getAdminUserList();
    }, [getAdminUserList]);

    /**
     * This function handles the click event for a side popup by resetting an input value and toggling
     * the state of a boolean variable.
     */
    const handleSidePopupClick = (type, item) => {
        if (type === 'Edit') {
            setInputValue({
                admin_first_name: item.first_name,
                admin_last_name: item.last_name,
                admin_email_address: item.email_address,
                admin_mobile_number: item.mobile_number,
                roles: item.roles
            })
            setEditValue(item)
        } else {
            setInputValue(initialInputValue)
        }
        setSideModelType(type);
        handleConformationClick()
        setAddOpen(!addOpen);
    }
    const handleSidePopupClickAction = () => {
        setInputValue(initialInputValue)
        setAddOpen(!addOpen);
    }
    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    function objectToQueryString(obj) {
        const keys = Object.keys(obj);
        let str = ''
        const keyValuePairs = keys.map((key, i) => {
            str += `${i === 0 ? `?` : '&'}${encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])}`;
        });
        return str
        // more code goes here
    }
    const handleExport = async () => {
        let params = Object.fromEntries(searchParams);
        delete params.page_number
        const body = { ...params }
        let url = ''
        url = searchParams.get('sort')
        let search = ''
        search = searchParams.get('search');
        params = objectToQueryString(params);

        // let params = Object.fromEntries(searchParams);
        // delete params.page_number
        // const body = { ...params }
        // let url = ''
        // url = searchParams.get('sort')
        const res = await dataService.GetAPI(`admin-users/export-csv${params}`);
        if (!res.error) {
            window.open(
                res.data.url,
                '_blank'
            );
            // window.location.href = res.data.url
            setToastmessage('File Exported Successfully')
        }

    }

    const handleActivate = async () => {
        setactivateLoading(true)
        const body = {
            status: modalpopup.status === true ? 'false' : 'true'
        }
        try {
            const res = await dataService.PatchAPI(body, `admin-users/activate-deactivate/${modalpopup['_id']}`);
            if (!res.error) {
                setToastmessage(`Admin user ${modalpopup.status === true ? 'deactivated' : 'activated'} successfully`)
                setactivateLoading(false);
                setmodalpopup({});
                getAdminUserList()

            } else {
                setToastErrorMessage(res.data.message);
                setactivateLoading(false);

            }

        } catch (error) {
            console.log(error)
            setToastErrorMessage(error?.message);
            setactivateLoading(false);
            setmodalpopup({})

        }



    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleClose = () => {
        setmodalpopup({});
        setactivateLoading(false)

    }
    return (
        <>
            <CardHeader header={'Admin User'} noIcon>
                <div className="bg-[#f5f5f5] px-[15px] pt-[14px] pb-[14px] mt-[110px] userHeight">
                    <div className=' bg-white h-customh10'>
                        <TopBar
                            AddButton={emptyScreenMessage === 'No data found' ? false : true}
                            SearchInput={emptyScreenMessage === 'No data found' ? false : true}
                            Tittle={'Admin User List'}
                            status={searchParams.get('status')}
                            AddButtonName={'Add User'}
                            SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                            handleOnClickSearch={handleSearchParams}
                            handleFilters={handleFilters}
                            createPath="/manage-admin-users/create"
                            handleSidePopupClick={handleSidePopupClick}
                            handleExport={handleExport}
                            tooltip="Add Admin User"
                            searchText="Name, Email Address, Phone Number"
                            privilegeRequired='add_admin_user'
                            admin={true}

                        />
                        <div className='bg-white'>
                            {<TableSection List={List} privilegeRequired='update_admin_user' tableLoading={loading} handleSearchParams={handleSearchParams} searchParams={searchParams} setmodalpopup={setmodalpopup} modalpopup={modalpopup} />}
                            {!loading && Math.ceil(List?.total_count / 10) > 1 && <Pagination
                                selectedPageNumber={searchParams.get('page_number')}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                TotalCount={List?.total_count}
                                totalPageNumber={Math.ceil(List?.total_count / 10)} />}
                        </div>
                    </div>
                </div>

                <Modal open={Object.keys(modalpopup).length > 0} onClose={handleClose}>
                    <Confirmationpopup
                        message={`Are you sure you want to ${modalpopup.status === true ? 'Deactivate' : 'Activate'} the admin user ${modalpopup.name}? `}
                        Title={`${modalpopup.status === true ? 'Deactivate' : 'Activate'} Admin User`}
                        handleSubmit={handleActivate}
                        stateKey={`${modalpopup.status === true ? 'Deactivate' : 'Activate'}`}
                        loading={activateLoading}
                        handleClose={handleClose} />

                </Modal>
            </CardHeader>

        </>
    );
}

export default ManageAdminUsers;
